import React from 'react';
import MoveBasicButton from '../Button/MoveBasicButton';
import { useTranslation } from 'react-i18next';

const FailContent = ({ completeTxt }) => {
  const { t } = useTranslation();

  const queryParams = new URLSearchParams(location.search);
  const url = queryParams.get('url');

  const goBackProductPage = () => {
    window.location.href = url;
  };

  return (
    <div className={'complete-wrapper fail-wrapper'}>
      <div className='icon-all-group'>
        <div className='icon-group'>
          <i className={'icon icon-fail'} />
        </div>
      </div>
      <div className='state-all-group'>
        <p className={'state-txt'}>{completeTxt}</p>
      </div>
      <div className='complete-button-group'>
        <MoveBasicButton buttonTxt={t('go_back_product_msg')} onClick={goBackProductPage} />
      </div>
    </div>
  );
};

export default FailContent;
